import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=51e7a682&scoped=true"
import script from "./UpgradeModal.vue?vue&type=script&lang=ts"
export * from "./UpgradeModal.vue?vue&type=script&lang=ts"
import style0 from "./UpgradeModal.vue?vue&type=style&index=0&id=51e7a682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7a682",
  null
  
)

export default component.exports